/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { Navigate, useSearchParams } from 'react-router-dom';

import { LoadingSpinnerFullPage } from '@/components/LoadingSpinnerFullPage';
import { useUserProfileQuery } from '@/hooks/query/useUserProfileQuery';
import { LogIn } from '@/pages/LogIn/LogIn';
import { selectedTenantIDKey } from '@/state/mgmtPlaneStore';

export function LogInPage() {
  const { isLoading, isError, data } = useUserProfileQuery({ refetchOnWindowFocus: false });
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');
  const emailMismatch = searchParams.get('emailMismatch');
  const redirectUrl = searchParams.get('redirectUrl');

  const triggerLogIn = (emailAddress: string) => {
    const encodedRedirectUrl = redirectUrl ? `&redirectUrl=${encodeURIComponent(redirectUrl)}` : '';
    window.location.href = `${window.mimicConfig.MIMIC_MGMT_PLANE_API}/api/auth/sign-in?email=${emailAddress}${encodedRedirectUrl}`;
  };

  if (isLoading) return <LoadingSpinnerFullPage />;
  if (!isError && data) {
    const userProfile = data.data;
    let { tenantID } = userProfile;
    if (userProfile.role === 'superadmin') {
      tenantID = localStorage.getItem(selectedTenantIDKey) || tenantID;
    }
    return <Navigate to={`/tenants/${tenantID}/activity`} replace />;
  }

  return <LogIn triggerLogIn={triggerLogIn} emailMismatch={emailMismatch} error={!!error} />;
}
